import React, { FC, useEffect } from 'react'
import { Text } from '@sitecore-jss/sitecore-jss-react'
import { BackToTopProps } from './BackToTop.types'
import { windowService } from '../../../../utils/window.utils'

import './styles.scss'

const BackToTop: FC<BackToTopProps> = ({ field }) => {
  const onClick = (): void =>
    windowService().scrollTo({ top: 0, behavior: 'smooth' })

  useEffect(() => {
    if (typeof window !== 'undefined' && 'customElements' in window) {
      import('@patternfly/pfe-icon-onhighway/dist/pfe-icon.js');
    }
  }, []);

  return (
    <div className="back-to-top" onClick={onClick}>
      <div>
        <Text tag="p" field={field} className="back-to-top__text" />
        <button
          className="back-to-top__button"
          type="button"
          aria-label="Back to top"
        >
          <pfe-icon
           icon="cnh-chevron-up"
           size="40"
           class="custom-arrow__icon"
          ></pfe-icon>
        </button>
      </div>
    </div>
  )
}

export default BackToTop
